export { default as IconFacebookSolid } from './Facebook.Solid'
export { default as IconInstagramOutline } from './Instagram.Outline'
export { default as IconLinkedInSolid } from './LinkedIn.Solid'
export { default as IconYouTubeSolid } from './YouTube.Solid'
export { default as IconPinterestSolid } from './Pinterest.Solid'
export { default as IconIntercomOutline } from './Intercom.Outline'

export { default as StyledIcon } from './Icon.Styled'
